const createElmFromStr = (str: string): Node[] => {
  const nodes = document.createRange().createContextualFragment(str).childNodes;
  return Array.from(nodes);
};

export function injectGoogleTagBody(content: string) {
  const js = createElmFromStr(content);
  console.log('injectGoogleTagBody', js);
  for (const node of js) {
    document.body.append(node);
  }
  return js;
}
export function injectGoogleTagHeader(content: string) {
  const js = createElmFromStr(content);
  console.log('injectGoogleTagHeader', js);
  for (const node of js) {
    document.head.append(node);
  }
  return js;
}
export function cleanGoogleTagBody(nodes: Node[]): void {
  for (const node of nodes) {
    document.body.removeChild(node);
  }
}
export function cleanGoogleTagHeader(nodes: Node[]): void {
  for (const node of nodes) {
    document.head.removeChild(node);
  }
}
